import type { IconSvgObject } from './types';

const MailUnlock01Icon: IconSvgObject = [
  ["path", { d: "M11.5 19H4C2.89543 19 2 18.1046 2 17V5C2 3.89543 2.89543 3 4 3H20C21.1046 3 22 3.89543 22 5V9.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M22 6L12.8944 10.5528C12.3314 10.8343 11.6686 10.8343 11.1056 10.5528L2 6", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M16.5 15.5H15V21H22V15.5H20.5H16.5ZM16.5 15.5V14C16.5 12.8954 17.3954 12 18.5 12C19.2403 12 19.8866 12.4022 20.2324 13", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default MailUnlock01Icon;
